import { createAction, props } from '@ngrx/store';
import { Permission } from '@bciti/types';
import { OrgEntry, ITokenScope } from '../auth.model';

// ─── OIDC actions ────────────────────────────────────────────────────────────

/** Set the org tag, configId, and decoded JWT claims after OIDC callback or app startup checkAuth */
export const SetOrgTagAction = createAction('[Auth] Set Org Tag', props<{ org: string; configId: string; roles: string[]; scopes: ITokenScope[]; permissions: Permission[] }>());

/** Store the full OrgEntry list fetched by SingleOidcConfigLoader */
export const SetOrgEntriesAction = createAction('[Auth] Set Org Entries', props<{ orgEntries: OrgEntry[] }>());

/** Clear all auth state (called by logout effect after logoff) */
export const ClearAuthStateAction = createAction('[Auth] Clear Auth State');

/** Initiate OIDC logout via OidcSecurityService */
export const LogoutAction = createAction('[Auth] Logout');

/** Used by logoutClearState$ to clear user slice */
export const ClearUserAction = createAction('[Auth] Clear User');

// ─── Deprecated stubs (Phase 4 cleanup) ─────────────────────────────────────
// These components still exist in GlobalModule but their routes redirect to /login.
// Remove these stubs when the components themselves are deleted in Phase 4.

/** @deprecated — no effects handle this */
export const RequestPasswordResetAction = createAction('[Auth] Request Password Reset (deprecated)', props<{ email: string }>());
/** @deprecated */
export const RequestPasswordResetSuccessAction = createAction('[Auth] Request Password Reset Success (deprecated)');
/** @deprecated */
export const RequestPasswordResetErrorAction = createAction('[Auth] Request Password Reset Error (deprecated)', props<{ error?: any }>());
/** @deprecated — no effects handle this */
export const ChangePasswordAction = createAction('[Auth] Change Password (deprecated)', props<{ credentials: any }>());
/** @deprecated */
export const ChangePasswordSuccessAction = createAction('[Auth] Change Password Success (deprecated)');
/** @deprecated */
export const ChangePasswordErrorAction = createAction('[Auth] Change Password Error (deprecated)', props<{ error?: any }>());
/** @deprecated — no effects handle this */
export const ConfirmAccountAction = createAction('[Auth] Confirm Account (deprecated)', props<{ token: string }>());
